export const PresetsActionTypes = {
    SET_CURRENT_PRESET_IDX : 'SET_CURRENT_PRESET_IDX'
}